import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { DataManagementService } from 'src/app/core/service/data-management.service';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { environment } from 'src/environments/environment';

// @Injectable({
//   providedIn: 'root'
// })
export class PayrollApiService {
  urlSeg = environment.payrollUrl
  constructor(protected http: HttpClient, protected dataService: DataManagementService) { }

  getPayrollById(tbl: string, id: string | number) {
    return lastValueFrom(this.http.get(`${this.urlSeg}/getById/${tbl}/${id}`));
  }
  getPayrollHeadById(id: string | number) {
    return lastValueFrom(this.http.get(`${this.urlSeg}/payrollhead/getById/${id}`));
  }
  savePayrollHead(data: any) {
    return lastValueFrom(this.http.post(`${this.urlSeg}/payrollhead/save`, data));
  }

  savePolicy(data: any) {
    return lastValueFrom(this.http.post(`${this.urlSeg}/leave/savepolicy`, data));
  }

  getPayrollFullData(tbl: string, cond: any = '', isFull = false, lazy = {}) {
    const tbl_ext = `/` + JSON.stringify(cond);
    const lasyP = isEmptyObj(lazy) ? '' : '/' + JSON.stringify(lazy);
    if (isFull) {
      return lastValueFrom(this.http.get(`${this.urlSeg}/getfull/${tbl}${tbl_ext}${lasyP}`,));
    } else {
      return lastValueFrom(this.http.get(`${this.urlSeg}/get/${tbl}${tbl_ext}${lasyP}`));
    }
  }

  savePayrollData(tbl: string, data: any) {
    return lastValueFrom(this.http.post(`${this.urlSeg}/saveData/${tbl}`, data));
  }

  getLeavePolicy(id: string | number) {
    return lastValueFrom(this.http.get(`${this.urlSeg}/leave/getPolicyById/${id}`));
  }
  saveLeavePolicy(data: any) {
    return lastValueFrom(this.http.post(`${this.urlSeg}/leave/savepolicy`, data));
  }
  deleteLeavePolicy(id: any) {
    return lastValueFrom(this.http.delete(`${this.urlSeg}/leave/deletePolicy/${id}`));
  }

  getStaffPayroll() {
    return this.dataService.apiCall(`${this.urlSeg}/payrollhead/staffPayroll`, 'payrollhead-staffPayroll');
  }
  getActiveHead() {
    return lastValueFrom(this.http.get(`${this.urlSeg}/payrollhead/getActive`));
  }
}